import React, { useState } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { checkTransactionStatus, resetPortfolio } from "../../api/user";
import { toast } from "react-toastify";
import ProcessingButton from "../Skeleton/ProcessingButton";

const CheckoutPortfolioForm = ({ clientSecret, onClose, profile }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false); // Track loading state
  const [errorMessage, setErrorMessage] = useState("");
  const userReset = JSON.parse(localStorage.getItem("userInfo"));

  // const billingDetails = {
  //   name: "Tarun Kumar",
  //   email: "tarunctpss@gmail.com",
  //   address: {
  //     line1: "123 Main St",
  //     line2: "Apt 4B",
  //     city: "New Delhi",
  //     state: "Delhi",
  //     postal_code: "110001",
  //     country: "IN",
  //   },
  // };

  const billingDetails = {
  name: userReset?.full_name || "Unknown User", // Use userReset.full_name or a fallback
  email: userReset?.email || "unknown@example.com", // Use userReset.email or a fallback
};


  // Handle Stripe payment confirmation

  //   const billingDetails = {
  //   name: userReset?.full_name || "Unknown User", // Use userReset.full_name or a fallback
  //   email: userReset?.email || "unknown@example.com", // Use userReset.email or a fallback
  // };

  // const handleSubmit = async (event) => {
  //   event.preventDefault();

  //   if (!stripe || !elements) {
  //     return; // Stripe or Elements not yet loaded
  //   }
  //   setLoading(true);
  //   // Confirm the card payment using the clientSecret
  //   const { error, paymentIntent } = await stripe.confirmCardPayment(
  //     clientSecret,
  //     {
  //       payment_method: {
  //         card: elements.getElement(CardElement),
  //         billing_details: billingDetails,
  //       },
  //     }
  //   );

  //   setLoading(false);
  //   if (error) {
  //     console.error("Payment failed:", error.message);
  //     setErrorMessage(error.message);
  //     alert("Payment failed. Please try again.");
  //   } else if (paymentIntent.status === "succeeded") {
  //     console.log(paymentIntent);
  //     alert("Payment successful! Portfolio reset.");
  //     const paymentId = paymentIntent.id;
  //     const response = await resetPortfolio(paymentId);
  //     if (response && response.data.message) {
  //       alert(response.data.message);
  //       onClose();
  //     } else {
  //       alert('Something went wrong with the portfolio reset. Please try again.');
  //     }
  //     onClose();
  //   } else {
  //     alert("Payment failed or was incomplete. Please try again.");
  //   }
  // };

  const pollTransactionStatus = async (
    paymentId,
    maxAttempts = 10,
    interval = 2000
  ) => {
    for (let attempt = 1; attempt <= maxAttempts; attempt++) {
      const transactionStatus = await checkTransactionStatus(paymentId);
      console.log(transactionStatus,'transactionStatus');

        if (transactionStatus.data && transactionStatus.data.status === "completed") {
          return true; // Status is completed
        }

      // Wait for the specified interval before the next attempt
      await new Promise((resolve) => setTimeout(resolve, interval));
    }

    return false; // Timeout or max attempts reached
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      return; // Stripe or Elements not yet loaded
    }
    setLoading(true);

    try {
      // Confirm the card payment using the clientSecret
      const { error, paymentIntent } = await stripe.confirmCardPayment(
        clientSecret,
        {
          payment_method: {
            card: elements.getElement(CardElement),
            billing_details: billingDetails,
          },
        }
      );



      if (error) {
        console.error("Payment failed:", error.message);
        setLoading(false);
        setErrorMessage(error.message);
        toast.error("Purchase did not complete. Try again.");
        // alert("Payment failed. Please try again.");
      } else if (paymentIntent.status === "succeeded") {
        console.log(paymentIntent);
        const paymentId = paymentIntent.id;
        try {
          // Make a request to your backend to confirm the transaction status has been updated
      const transactionConfirmed = await pollTransactionStatus(paymentId);

          if (transactionConfirmed) {
            // Proceed with resetting the portfolio
            const response = await resetPortfolio(paymentId);
            if (response && response.data.message) {
              setLoading(false);
              toast.success("The Record has been reset.");
              onClose();
            } else {
              setLoading(false);
              toast.error("Purchase confirmed, but we could not confirm that The Record was reset. Contact support before trying again.");
            }
          }
          else {
            setLoading(false);
            toast.error("Purchase pending. The Record has not been reset yet.");
          }
        } catch (error) {
          setLoading(false);
          console.error("Error:", error.message);
          toast.error("We could not confirm that The Record was reset. Contact support before trying again.");
        }
      } else if (paymentIntent.status === "processing") {
        setLoading(false);
        toast.info("Purchase pending. The Record has not been reset yet.");
        // alert("Payment is in progress. Please wait for further updates.");
      } else {
        setLoading(false);
        toast.error("Purchase did not complete. Try again.");
        //  alert("Payment failed or was incomplete. Please try again.");
      }
    } catch (err) {
      setLoading(false);
      console.error("Unexpected error:", err);
      alert("An unexpected error occurred. Please try again.");
    }
  };

  return (
    <div className="fixed z-50 inset-0 overflow-y-auto">
      <div className="flex items-center justify-center px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <div className="flex items-center justify-center fixed z-50 inset-0 overflow-y-auto">
          <div className="w-full flex items-center justify-center pt-4 pb-20 text-center sm:block sm:p-0">
            <div className="bg-white rounded-lg shadow-xl max-w-lg mx-auto sm:my-8 p-6">
              <div className="flex justify-between">
                <div></div>
              </div>
              <h2 className="text-lg font-bold text-primaryColor mb-4">
                Reset Portfolio
              </h2>
              <form onSubmit={handleSubmit}>
                {/* <CardElement /> */}
                <CardElement
                  options={{
                    hidePostalCode: true, // Disables the ZIP code field
                    style: {
                      base: {
                        fontSize: "16px",
                        color: "#424770",
                        "::placeholder": {
                          color: "#aab7c4",
                        },
                      },
                      invalid: {
                        color: "#9e2146",
                      },
                    },
                  }}
                />

                {/* Display error message if payment failed */}
                {errorMessage && (
                  <div className="error-message">{errorMessage}</div>
                )}

                <div className="flex items-center justify-center space-x-4 mt-10">
                  <ProcessingButton
                    type="submit"
                    processing={loading}
                    unavailable={!stripe && !loading}
                    label="Pay"
                    processingLabel="Paying"
                    className="w-32 bg-primaryColor hover:bg-primaryColor text-white font-bold py-2 px-3 rounded-full focus:outline-none focus:shadow-outline"
                    unavailableClassName="opacity-60"
                  />

                  <button
                    className="w-32 bg-primaryColor hover:bg-primaryColor text-white font-bold py-2 px-3 rounded-full focus:outline-none focus:shadow-outline"
                    onClick={onClose}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutPortfolioForm;
